<template>
    <div>
     <b-modal size="TP_Problem" :id="ModalId"
     @shown="prepararDrag"
      :visible="true" centered no-close-on-backdrop no-close-on-esc :title="TitleWindow" ref="modalEditProblemTP" @close="this.emitEventCancel"  @ok="handleOk" :ok-title="$t('Shared.Save')"  @cancel="this.emitEventCancel" :cancel-title="$t('Shared.BtnCancel')"> 
      <form ref="form_ProblemEdit" @submit.stop.prevent="handleSubmit">
            <b-row>                  
              <b-col md="12">
                <MdEdit v-bind:Label="$t('modalEditGoal.dIdentified')" v-bind:Name="'DateIndentified'" v-bind:TypeProp="'text'"
                  v-bind:Mask="'##/##/####'" v-bind:Min="'1900-01-01'" v-bind:Max="'2200-12-31'"
                  v-model="dateidentified" 
                />
              </b-col>
          </b-row>    
        </form>            
               
          
       
     </b-modal>  
    </div>
</template>
 
 <script>
 import Utils from '@/common/utils'
 import ShowMessage from '@/components/messages/ShowMessage.js'
 //import IncidentReportInterventionsSetups from '@/services/incidentreportinterventionssetups.service'
 //import IncidentReportSeveritySetup from '@/services/incidentreportseveritysetup.service'
 import TreatmentPlan from '@/services/treatmentplan.service'

 export default {
   name: 'ModalEditProblemTP',
   mixins: [ShowMessage],  
   props: {
     ModalId: String,
     ProbDesc:String,
     DiagDesc:String,
     DiagCode:String,
     TitleWindow: String,
     ProblemRecId:String,
     ProblemDateIdentified:String,
     Signatures:Array 
   },
   
   data(){
     return {
        dateidentified:this.ProblemDateIdentified,
     }
   },
 
   methods:{

     prepararDrag() {
  this.$nextTick(() => {
    const outer = document.getElementById(`${this.ModalId}___BV_modal_outer_`);
    if (!outer) {
      console.warn("No se encontró el contenedor del modal");
      return;
    }

    const dialog = outer.querySelector(".modal-dialog");
    const header = outer.querySelector(".modal-header");

    if (!dialog || !header) {
      console.warn("No se encontró header o dialog");
      return;
    }

    header.style.cursor = "move";

    header.onmousedown = (e) => {
      e.preventDefault();

      // Obtener posición actual antes de tocar estilos
      const rect = dialog.getBoundingClientRect();
      const offsetX = e.clientX - rect.left;
      const offsetY = e.clientY - rect.top;

      // Fijar posición actual (solo en el primer movimiento)
      dialog.style.width = `${rect.width}px`;
      dialog.style.height = `${rect.height}px`;
      dialog.style.position = "fixed";
      dialog.style.left = `${rect.left}px`;
      dialog.style.top = `${rect.top}px`;
      dialog.style.margin = 0;
      dialog.style.transform = "none";

      const moveHandler = (eMove) => {
        dialog.style.left = `${eMove.clientX - offsetX}px`;
        dialog.style.top = `${eMove.clientY - offsetY}px`;
      };

      document.addEventListener("mousemove", moveHandler);
      document.addEventListener(
        "mouseup",
        () => document.removeEventListener("mousemove", moveHandler),
        { once: true }
      );
    };
  });
},

     emitEventOK(/*bvModalEvent*/){
       /*if (this.validateFields()) {
         this.categoryItems.incidentTypes = this.IncidentCodes
         this.setInterventions()
         if (this.ModeEdit == false) {
           this.categoryItems.id = Utils.generateRecID()
         }               
         this.$emit('getCodeConditionOK',this.categoryItems);
       } else {       
         bvModalEvent.preventDefault()
       }    */  
       this.UpdateProblem();
     },

     checkFormValidity() {    
       return Utils.ValidateDate(this.dateidentified, Utils.getShortDateFormat()) ? true : false; 
      },

     handleOk(bvModalEvt) {      
        bvModalEvt.preventDefault();      
        this.handleSubmit()
      },

     handleSubmit() {       
        !this.checkFormValidity() ? this.showMessage(this.$tc('Msg.Error'),this.$t('modalEditTPProblem.invalMsg'),"error"):this.emitEventOK();
      },


      UpdateProblem(){
        //if(this.IsValidFieldDate(this.dateidentified)){
            console.log('MdE', this.dateidentified)
        var data = {
            probDate:Utils.formatterToISO(this.dateidentified, Utils.getShortDateFormat())
        }
         TreatmentPlan.UpdateProblem(this.ProblemRecId,data)
            .then((response) => { 
               if(response.data){
                this.$emit('RefreshGetTP');
                setTimeout(() => 
                        this.$bvToast.toast(this.$t('treatmentplan.ProblemSaved'), {
                         title: this.$t('Msg.Success'),
                          autoHideDelay: 5000,
                          variant: "success"
                        })
                        , 20); 
               }             
            })
            .catch((error) => {
                if (!error.response) {
                        this.showMessage(this.$tc('Msg.Error'),this.$t('Msg.NotAbleToUpdate'),"error");
                }     
                   else if(error.response.status === 400 ){
                     this.showMessage(this.$tc('Msg.Error'),error.response.data.errorMessage,"error");
                     }   
                     else if(error.response.status === 500){
                        this.showMessage(this.$tc('Msg.Error'),this.$t('Msg.ThereWereSomeError'),"error");
                     } else{
                         this.showMessage(this.$tc('Msg.Error'),error.response.data.errorMessage,"error");
                     }    
            });
       
          
          },

       
     emitEventCancel(){
      this.$emit('ModalTPEditProblemCANCEL');
    },    
   },
 
  mounted(){
    
   },
 };
 </script>

 <style>
.custom-modal-header {
  cursor: move;
  user-select: none;
}

.modal-header {
  cursor: move;
  user-select: none;
}

.modal-dialog {
  transition: none !important;
  transform: none !important;
}

.modal-dialog.dragging {
  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.4);
  opacity: 0.98;
  cursor: grabbing !important;
  transition: box-shadow 0.2s ease;
}
.modal-header {
  user-select: none; /* evita seleccionar texto al arrastrar */
}
</style>

